// Helper function to render styled option label
export const renderLabelStyle = (label: string) => {
  // Split the label at the first space to separate ID from the rest
  const parts = label.split(' ');
  const id = parts?.[0]; // "FID0123462"
  const rest = parts?.slice(1)?.join(' '); // "- Jessica | 70021255"

  return (
    <>
      <span className="text-brand-primary-darkest">{id}</span>
      {rest && <span className="text-neutral-n7"> {rest}</span>}
    </>
  );
};
